import { maxDateValidator, minDateValidator } from "./validators.date";
import { decimalsValidator } from "./validators.decimals";

export class DffValidators {
    public static minDate = minDateValidator;
    public static maxDate = maxDateValidator;
    public static decimals = decimalsValidator;
}
